<template>
	<div>
		<div v-for="(item,index) in data" :key="index">
			<p class="title"> {{item.name}}接口</p>
			<p>（1）接口基本信息：</p>
			<el-table :data="item.data1" border>
				<el-table-column prop="name" label="名称" width="180">
				</el-table-column>
				<el-table-column prop="info" label="接口信息" width="1000">
				</el-table-column>
			</el-table>
			<p>（2）请求参数说明：</p>
			<el-table :data="item.data2" border>
				<el-table-column prop="name" label="参数" width="180">
				</el-table-column>
				<el-table-column prop="is" label="必填" width="180">
				</el-table-column>
				<el-table-column prop="info" label="参数描述" width="1000">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [
					{
					name: '1.bind',
					data1: [{

							name: '接口简介',
							info: '由uid、clientid完成绑定客户端ID'
						},
						{

							name: '接口地址',
							info: 'https://msg.yfcat.com/index/message/bind'
						},
						{

							name: '请求方式',
							info: 'POST'
						},
					],
					data2: [{
						is:1,
						name: 'uid',
						info: '用户id'
					},
					 {
					 	is:1,
					 	name: 'clientid',
					 	info: '客户端ID'
					 },
					 {
					 	is:1,
					 	name: 'appid',
					 	info: '应用ID'
					 },
					{
						is:0,
						name: 'groupid',
						info: '用户已加入的群聊ID，多个则用英文逗号分隔'
					},
					 {
					 	is:0,
					 	name: 'friendid',
					 	info: '用户的好友ID列表，多个则用英文逗号分隔(允许白名单外用户收发消息时，此参数可不传)'
					 },
					 {
					 	is:0,
					 	name: 'blacklistid',
					 	info: '用户的黑名单用户ID列表，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '2.sendMsg',
					data1: [{
				
							name: '接口简介',
							info: '客户端发送消息'
						},
						{
				
							name: '接口地址',
							info: 'https://msg.yfcat.com/index/message/sendMsg'
						},
						{
				
							name: '请求方式',
							info: 'POST'
						},
					],
					data2: [{
						is:1,
						name: 'appid',
						info: '应用ID'
					},
					 {
					 	is:1,
					 	name: 'msg',
					 	info: '消息文本(自定义文本格式)'
					 },
					 {
					 	is:1,
					 	name: 'uid',
					 	info: '用户id'
					 },
					{
						is:1,
						name: 'toid',
						info: '接收人UID'
					},
					 {
					 	is:0,
					 	name: 'totype',
					 	info: '1 用户消息（默认） 2 群组消息'
					 },
					 {
					 	is:1,
					 	name: 'oauth_token',
					 	info: 'oauth_token接口调用凭据'
					 },
					 ],
				},
				]
			}
		}
	}
</script>

<style scoped="scoped">
	.title {
		font-size: 20px;
		font-weight: 600;
	}

	p {
		width: 80%;
	}
</style>
